import { IdentifierTypeViewModel, IdentifierTypeCreateCommand, IdentifierTypeUpdateCommand } from '../../models/Entities/Person/IdentifierType/IdentifierTypeModels';
import { ErrorType } from '../../models/HttpError';

export const PERSON_IDENTIFIER_TYPE_GETALL_REQUEST = 'PERSON_IDENTIFIER_TYPE_GETALL_REQUEST';
export const PERSON_IDENTIFIER_TYPE_GETALL_SUCCESS = 'PERSON_IDENTIFIER_TYPE_GETALL_SUCCESS';
export const PERSON_IDENTIFIER_TYPE_GETALL_FAILURE = 'PERSON_IDENTIFIER_TYPE_GETALL_FAILURE';

export interface PersonIdentifierTypeGetAllRequestAction {
    type: typeof PERSON_IDENTIFIER_TYPE_GETALL_REQUEST;
}

export interface PersonIdentifierTypeGetAllSuccessAction {
    type: typeof PERSON_IDENTIFIER_TYPE_GETALL_SUCCESS;
    payload: IdentifierTypeViewModel[];
}

export interface PersonIdentifierTypeGetAllFailureAction {
    type: typeof PERSON_IDENTIFIER_TYPE_GETALL_FAILURE;
    error: ErrorType;
}

export const PERSON_IDENTIFIER_TYPE_GETBYID_REQUEST = 'PERSON_IDENTIFIER_TYPE_GETBYID_REQUEST';
export const PERSON_IDENTIFIER_TYPE_GETBYID_SUCCESS = 'PERSON_IDENTIFIER_TYPE_GETBYID_SUCCESS';
export const PERSON_IDENTIFIER_TYPE_GETBYID_FAILURE = 'PERSON_IDENTIFIER_TYPE_GETBYID_FAILURE';

export interface PersonIdentifierTypeGetByIdRequestAction {
    type: typeof PERSON_IDENTIFIER_TYPE_GETBYID_REQUEST;
    id: number;
}

export interface PersonIdentifierTypeGetByIdSuccessAction {
    type: typeof PERSON_IDENTIFIER_TYPE_GETBYID_SUCCESS;
    payload: IdentifierTypeViewModel;
}

export interface PersonIdentifierTypeGetByIdFailureAction {
    type: typeof PERSON_IDENTIFIER_TYPE_GETBYID_FAILURE;
    error: ErrorType;
}

export const PERSON_IDENTIFIER_TYPE_CREATE_REQUEST = 'PERSON_IDENTIFIER_TYPE_CREATE_REQUEST';
export const PERSON_IDENTIFIER_TYPE_CREATE_SUCCESS = 'PERSON_IDENTIFIER_TYPE_CREATE_SUCCESS';
export const PERSON_IDENTIFIER_TYPE_CREATE_FAILURE = 'PERSON_IDENTIFIER_TYPE_CREATE_FAILURE';

export interface PersonIdentifierTypeCreateRequestAction {
    type: typeof PERSON_IDENTIFIER_TYPE_CREATE_REQUEST;
    payload: IdentifierTypeCreateCommand;
}

export interface PersonIdentifierTypeCreateSuccessAction {
    type: typeof PERSON_IDENTIFIER_TYPE_CREATE_SUCCESS;
    payload: IdentifierTypeViewModel;
}

export interface PersonIdentifierTypeCreateFailureAction {
    type: typeof PERSON_IDENTIFIER_TYPE_CREATE_FAILURE;
    error: ErrorType;
}

export const PERSON_IDENTIFIER_TYPE_UPDATE_REQUEST = 'PERSON_IDENTIFIER_TYPE_UPDATE_REQUEST';
export const PERSON_IDENTIFIER_TYPE_UPDATE_SUCCESS = 'PERSON_IDENTIFIER_TYPE_UPDATE_SUCCESS';
export const PERSON_IDENTIFIER_TYPE_UPDATE_FAILURE = 'PERSON_IDENTIFIER_TYPE_UPDATE_FAILURE';

export interface PersonIdentifierTypeUpdateRequestAction {
    type: typeof PERSON_IDENTIFIER_TYPE_UPDATE_REQUEST;
    payload: IdentifierTypeUpdateCommand;
}

export interface PersonIdentifierTypeUpdateSuccessAction {
    type: typeof PERSON_IDENTIFIER_TYPE_UPDATE_SUCCESS;
    payload: IdentifierTypeViewModel;
}

export interface PersonIdentifierTypeUpdateFailureAction {
    type: typeof PERSON_IDENTIFIER_TYPE_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const PERSON_IDENTIFIER_TYPE_DELETE_REQUEST = 'PERSON_IDENTIFIER_TYPE_DELETE_REQUEST';
export const PERSON_IDENTIFIER_TYPE_DELETE_SUCCESS = 'PERSON_IDENTIFIER_TYPE_DELETE_SUCCESS';
export const PERSON_IDENTIFIER_TYPE_DELETE_FAILURE = 'PERSON_IDENTIFIER_TYPE_DELETE_FAILURE';

export interface PersonIdentifierTypeDeleteRequestAction {
    type: typeof PERSON_IDENTIFIER_TYPE_DELETE_REQUEST;
    id: number;
}

export interface PersonIdentifierTypeDeleteSuccessAction {
    type: typeof PERSON_IDENTIFIER_TYPE_DELETE_SUCCESS;
    id: number;
}

export interface PersonIdentifierTypeDeleteFailureAction {
    type: typeof PERSON_IDENTIFIER_TYPE_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
